// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__LFvp9","__TEMPORALTITLE":"About___TEMPORALTITLE__1-Wwe"};